import Action from '../../Action'
// import './styles/ModalDeleteCis.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { lang } from '../../generales/traduction';
import { capitalizeFirstLetter } from '../../../utils/utils';
const ModalDeleteCis =({languaje,handleShowPopup,mode,cis,closDeleteCisModal,setRegisterIsValid,setData,setLoading,setError,server})=>{
    const [loadingM,setLoadingM]=useState(false);
    const Eliminar=()=>{
        setLoading(true)
        setRegisterIsValid(true)
        const fetchDataPost = async () => {
          let url=(typeof cis.conf_id=='undefined')?server.url+'/api/v1/cassia/ci_elements/'+cis.element_id:server.url+'/api/v1/cassia/ci_elements/history/'+cis.conf_id
       try {
           const response = await fetch(server.url+'/api/v1/cassia/cis_v2/'+cis.id, {
            
           // const response = await fetch(url, {
             method: 'DELETE',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             setRegisterIsValid(false)
             // Manejo de la respuesta
             setData(data1)
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])),'', true)
             closDeleteCisModal()
             // console.log(data1);
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
            // Manejo de errores
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            setError(error)
            console.error(error);
          }
        };

        fetchDataPost();
    }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs delete-modal-gs'>
                            {/* <div className='head-card-modal-gs delete-modal-gs'>
                                <div className='title-head-card-modal-gs'>
                                   ELIMINAR CONFIGURACION
                                </div>
                            </div> */}
                            <div className='content-card-modal-gs'>
                                <div className='cont-info-modal-delete-gs'>
                                    <div className='cont-message-modal-delete-gs'>
                                            <div className='txt-message-modal-delete-gs'>
                                                {capitalizeFirstLetter(lang[languaje]['eliminar'])+"  "+capitalizeFirstLetter(lang[languaje]['configuracion'])}
                                            </div>
                                    </div>
                                    <div className='cont-user-modal-delete-gs'>
                                            <div className='txt-user-modal-delete-gs'>
                                                {cis.folio+" - "+cis.name}
                                            </div>
                                    </div>
                                    <div className='cont-btn-modal-delete-gs'>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                <Action  disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])}  action={Eliminar}></Action>
                                            <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteCisModal}></Action>
                                                </>
                                            }
                                    </div>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalDeleteCis